import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { FiltersProvider } from "../context/FiltersContext";
import { Sidebar } from "../components/Sidebar";
import { Loader2 } from "lucide-react";

export default function AppLayout() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="app-loading">
        <Loader2 className="w-6 h-6 animate-spin text-[#002FA7]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  return (
    <FiltersProvider>
      <div className="min-h-screen flex bg-[#F8FAFC]" data-testid="app-layout">
        <Sidebar />
        <main className="flex-1 min-w-0 flex flex-col">
          <Outlet />
        </main>
      </div>
    </FiltersProvider>
  );
}
